var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c(
        "div",
        { staticClass: "dashboard-block text-center" },
        [
          _c("div", { staticClass: "row m-b-md" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6",
              },
              [
                _c("div", { staticClass: "payment-container text-center" }, [
                  _c("p", { staticClass: "lead" }, [
                    _vm._v(
                      "\n              We have received your " +
                        _vm._s(_vm.paymentType) +
                        " payment"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n              for booking #" +
                        _vm._s(_vm._f("padded")(_vm.booking.id, "0", 5)) +
                        ".\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "A receipt will be emailed to you. Please allow 3 - 5 business days."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "decorative-divider" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "paid-amount" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.paymentAmount))),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              attrs: {
                to: { name: "bookings.show", params: { id: _vm.booking.id } },
              },
            },
            [
              _c("i", { staticClass: "fa fa-angle-left" }),
              _vm._v("   Back to booking.\n      "),
            ]
          ),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c(
                "div",
                {
                  staticClass: "row m-b-md",
                  staticStyle: { "padding-top": "20px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "payment-container text-center" },
                        [
                          _c("p", { staticClass: "lead" }, [
                            _vm._v(
                              "\n              Admin Options\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-sm btn-info",
                              attrs: { click: _vm.handleMarkPaymentAsUnpaid },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.bothPaymentsShareSameTransaction
                                      ? "Mark Both Payments As Unpaid"
                                      : "Mark Payment As Unpaid"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.bothPaymentsShareSameTransaction
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#919191",
                                    "font-size": "13px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "As the payments were paid together, they must both be marked unpaid"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", { staticClass: "text-center" }, [_vm._v("Thanks!")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }